<div class="edit-page-root-container area-edit-root-container">
  <div class="page-content">
    <div class="page-header">
      <button mat-button class="nav-button" (click)="navBack()">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_edit){
        <button mat-flat-button class="action-btn btn-discard" (click)="navBack()">DISCARD</button>
        <button mat-flat-button class="action-btn btn-save" (click)="save()">SAVE</button>
        }
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <mat-tab-group>
              <mat-tab label="General">
                <div class="tab-content">
                  <div class="input-group">
                    <div class="input-box-left">
                      <mat-form-field class="code">
                        <mat-label>Code</mat-label>
                        <input matInput formControlName="code" maxlength="50" appCodeInput
                          [readonly]="TerminalInfo.id !== undefined && TerminalInfo.id !== 0">
                        <mat-error *ngIf="editForm.controls['code'].hasError('required')"> code should be
                          entered</mat-error>
                        <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                          10.</mat-error>
                      </mat-form-field>
                    </div>

                    <div class="input-box-right">
                      <mat-form-field class="name">
                        <mat-label>Name</mat-label>
                        <input matInput formControlName="name">
                        <mat-error *ngIf="editForm.controls['name'].hasError('required')">Terminal name should be
                          entered</mat-error>
                        <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is
                          50.</mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="input-group">
                    <div class="input-box-left">
                      <mat-form-field class="short-code">
                        <mat-label>Short-code</mat-label>
                        <input matInput formControlName="short_code" maxlength="50"
                          [readonly]="TerminalInfo.id !== undefined && TerminalInfo.id !== 0">
                        <mat-error *ngIf="editForm.controls['code'].hasError('required')">Terminal code should be
                          entered</mat-error>
                        <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is
                          10.</mat-error>
                      </mat-form-field>
                    </div>

                    <div class="input-box-right">
                      <mat-form-field class="service-type">
                        <mat-label>Service Type</mat-label>
                        <mat-select formControlName="type">
                          <mat-option [value]="1">Counter</mat-option>
                          <mat-option [value]="2">Restaurant</mat-option>
                          <mat-option [value]="3">Drive-through</mat-option>
                        </mat-select>
                        <mat-error *ngIf="editForm.controls['type'].hasError('required')">Service type should be
                          selected</mat-error>
                      </mat-form-field>
                    </div>
                  </div>

                  <mat-form-field class="description">
                    <mat-label>Description</mat-label>
                    <textarea matInput formControlName="description"></textarea>
                    <mat-error *ngIf="editForm.controls['description'].hasError('maxlength')">Maximum length is
                      200.</mat-error>
                  </mat-form-field>

                  <mat-checkbox formControlName="is_oo_terminal" class="oo-terminal-checkbox">
                    Online Order Terminal
                  </mat-checkbox>
                  <mat-checkbox formControlName="is_active" class="oo-terminal-checkbox">
                    Active
                  </mat-checkbox>
                </div>
              </mat-tab>

              <mat-tab label="Settings" *ngIf="editForm.get('type')?.value === 3">

                <div class="tab-content">
                  <div class="input-group">
                    <div class="input-box-left">
                      <mat-form-field class="operation-mode">
                        <mat-label>Operation mode</mat-label>
                        <mat-select formControlName="operation_mode">
                          <mat-option [value]="1">Master</mat-option>
                          <mat-option [value]="2">Slave</mat-option>

                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="input-box-right">
                      <mat-form-field class="service-type" *ngIf="editForm.get('operation_mode')?.value === 2">
                        <mat-label>Master Terminal</mat-label>
                        <mat-select formControlName="parent_id">
                          <mat-option *ngFor="let terminal of TerminalData" [value]="terminal.id">
                            {{ terminal.name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="input-box-right">
                    <mat-form-field class="share-orders">
                      <mat-label>Share orders</mat-label>
                      <mat-select formControlName="is_order_shared">
                        <mat-option [value]="1">Yes</mat-option>
                        <mat-option [value]="0">NO</mat-option>

                      </mat-select>
                    </mat-form-field>
                  </div>





                  <h3 style="margin-left: 10px;">Disabled Functions</h3>
                  <div class="checkbox-container">

                    <!-- Left Column -->
                    <div class="column">

                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('day_process')"
                          (change)="onCheckboxChange($event)" value="day_process"
                          [ngClass]="{'readonly-checkbox': editForm.get('operation_mode')?.value === 2}">
                          <span>DayStart/Day End</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('shift_summary')"
                          (change)="onCheckboxChange($event)" value="shift_summary">
                          <span>Summary</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('order_details_export')"
                          (change)="onCheckboxChange($event)" value="order_details_export">
                          <span>Order Details</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('order_refund')"
                          (change)="onCheckboxChange($event)" value="order_refund">
                          <span>Order Refund</span>
                        </mat-checkbox>
                      </div>
                    </div>

                    <!-- Second Column -->
                    <div class="column">
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('change_customer')"
                          (change)="onCheckboxChange($event)" value="change_customer">
                          <span>Change Customer</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('bill_discount')"
                          (change)="onCheckboxChange($event)" value="bill_discount">
                          <span>Bill Discounts</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('edit_item')"
                          (change)="onCheckboxChange($event)" value="edit_item">
                          <span>Item Edit</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('daily_expense')"
                          (change)="onCheckboxChange($event)" value="daily_expense">
                          <span>Edit Daily Expense</span>
                        </mat-checkbox>
                      </div>
                    </div>

                    <!-- Third Column -->
                    <div class="column">
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('open_till')"
                          (change)="onCheckboxChange($event)" value="open_till">
                          <span>Open Till/Close Till</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('shift_report')"
                          (change)="onCheckboxChange($event)" value="shift_report">
                          <span>Shift Reports</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('sync_now')"
                          (change)="onCheckboxChange($event)" value="sync_now"
                          [ngClass]="{'readonly-checkbox': editForm.get('operation_mode')?.value === 2}">
                          <span>Sync Now</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('order_entry')"
                          (change)="onCheckboxChange($event)" value="order_entry">
                          <span>Order Entry</span>
                        </mat-checkbox>
                      </div>
                    </div>

                    <!-- Fourth Column -->
                    <div class="column">
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('change_menu')"
                          (change)="onCheckboxChange($event)" value="change_menu">
                          <span>Menu</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('open_cash_drawer')"
                          (change)="onCheckboxChange($event)" value="open_cash_drawer">
                          <span>Open Cash Drawer</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('oo_cancel')"
                          (change)="onCheckboxChange($event)" value="oo_cancel">
                          <span>Online Order Cancel</span>
                        </mat-checkbox>
                      </div>
                      <div class="pos-funct-div">
                        <mat-checkbox name="disabled_pos_functions[]"
                          [checked]="(editForm.get('disabled_pos_functions')?.value || []).includes('oo_revert_status')"
                          (change)="onCheckboxChange($event)" value="oo_revert_status">
                          <span>OO Status Revert</span>
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
      </form>
    </div>


  </div>
</div>